var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19615 6H7.19615V12H3.19615V6Z",
    fill: "#458FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19615 0L10.3923 6H0L5.19615 0Z",
    fill: "#458FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloUp);
export default __webpack_public_path__ + "static/media/hilo-up.16c87bb4450de29a62b5f553290608e5.svg";
export { ForwardRef as ReactComponent };